module.exports = __webpack_public_path__ + "img/login.23145830.png";